import React, { Fragment } from 'react';
import { H3, H4 } from '~typography';
import { Row, Col } from '~layout';
import { ContentRenderer } from '~helpers';
import commercePropTypes from '../../prop-types/commercePropTypes';

var Policy = function Policy(_ref) {
  var policyTitle = _ref.policyTitle,
      policyList = _ref.policyList;
  return policyList && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xxs: 30
  }, /*#__PURE__*/React.createElement(H3, null, policyTitle)), /*#__PURE__*/React.createElement(Col, null, policyList.map(function (item, index) {
    var policyGroupTitle = item.policyTitle,
        policy = item.policy;
    return /*#__PURE__*/React.createElement(Row, {
      key: index
    }, /*#__PURE__*/React.createElement(Col, {
      lg: 12
    }, /*#__PURE__*/React.createElement(H4, null, policyGroupTitle)), /*#__PURE__*/React.createElement(Col, {
      lg: 18
    }, policy.map(function (policyItem, policyItemIndex) {
      var policyItemTitle = policyItem.policyItemTitle,
          policyItemBody = policyItem.policyItemBody;
      return /*#__PURE__*/React.createElement(Fragment, {
        key: policyItemIndex
      }, /*#__PURE__*/React.createElement(H4, null, policyItemTitle), /*#__PURE__*/React.createElement(ContentRenderer, {
        source: policyItemBody
      }));
    })));
  })));
};

Policy.defaultProps = {
  policyTitle: undefined
};
export default Policy;